module.exports = __webpack_public_path__ + "static/sphere_splash_circles-7e58e2ee08854a48b225b69af48eade9.png";